import React, { useState } from "react";
import { Grid, Typography } from "@mui/material";
import Header from "../../Header/Header";
import { CustomerDTO } from "@beable/roster-backend-client-v1";
import Upload from "./Upload";
import AcademicYearSelector from "../../Common/AcademicYearSelector";
import CustomerSelector from "../../Common/CustomerSelector";
import SiteSelector from "../../Common/SiteSelector";
import { AcademicYearDTO, SiteDTO } from "@beable/roster-backend-client-v1";
import BasePanel from "../../Common/Layout/BasePanel";
import { BasePanelBox } from "../../Common/Layout/BasePanelBox";
import { StyledPanelHeader } from "../../Common/Layout/PanelHeader";
import BaseSheet from "../../Common/Layout/BaseSheet";

export default function ClosedDates() {
  const [customer, setCustomer] = useState<CustomerDTO>();
  const [site, setSite] = useState<SiteDTO>();
  const [academicYear, setAcademicYear] = useState<AcademicYearDTO>();

  const handleCustomerChange = (customer: CustomerDTO) => {
    setCustomer(customer);
  };

  const handleSiteChange = (site: SiteDTO) => {
    if (site) setSite(site);
    else setSite(undefined);
  };

  return (
    <>
      <Header />
      <Grid container>
        <BasePanel>
          <BasePanelBox>
            <StyledPanelHeader header="Upload the Closed Dates CSV" />
            <Grid container size={12}>
              <CustomerSelector
                onSelect={handleCustomerChange}
                variant="outlined"
              />
              <SiteSelector
                customerId={customer ? customer.id : ""}
                onSelect={handleSiteChange}
                disabled={!customer}
                variant="outlined"
              />
              <AcademicYearSelector
                siteId={site ? site.id : 0}
                handleSelection={(academicYear: AcademicYearDTO | undefined) =>
                  setAcademicYear(academicYear)
                }
                disabled={!site}
                variant="outlined"
              />
            </Grid>
          </BasePanelBox>
        </BasePanel>
        <BaseSheet>
          <Grid size={12}>
            <Upload site={site} academicYear={academicYear} />
          </Grid>
          <Grid size={12}>
            <br />
            <Typography component="body">
              <b>Note:</b> Dates must be formatted as "YYYY-MM-DD". 'Skip Content' field must have a value of either TRUE or FALSE.
            </Typography>
          </Grid>
        </BaseSheet>
      </Grid>
    </>
  );
}
